export default __webpack_public_path__ + "static/media/oportunity.69e3b57b.png";